/** @format */

import { toast } from 'react-toastify';

export const success = (message) => {
	toast.success(message, {
		position: toast.POSITION.BOTTOM_CENTER,
		autoClose: 5000,
		closeOnClick: true,
	});
};

export const error = (message) => {
	toast.error(message, {
		position: toast.POSITION.BOTTOM_CENTER,
		autoClose: 7000,
		closeOnClick: true,
	});
};

export const info = (message) => {
	toast.info(message, {
		position: toast.POSITION.BOTTOM_CENTER,
		autoClose: 5000,
		closeOnClick: true,
	});
};
